import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import Constants from "../business/Constants";

class GiocaCodiceCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.startLoader();

        GigyaManager.getLoggedUserCached().then((u) => {
            var ch = u.data[Constants.CH_PROMO];
            if(typeof ch !== "undefined" && ch != null && ch != ""){
                $('#regulationAcceptance').remove();
            }

            this.removeLoader();
        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        })


    }

    submitForm(){

        if(!$('#conferma').prop("disabled")){
            $('#conferma').prop("disabled", true);
            if ($('.error-feedback').length){
                $('.error-feedback').remove();
            }
            let codice = $('#codice').val();

            let validCode = this.take_code();
            let validRegAccpt = this.take_acceptance();
            if(validCode && validRegAccpt){
                this.startLoader();
                if($('#acceptance').length){
                    GigyaManager.addCH(Constants.CH_PROMO).then(()=>{
                        this.doPlayCodeCall(codice);
                    }, ()=>{
                        let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Errore durante l'accettazione del regolamento</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
                        $(this.element).append(tmplModalGeneric);
                        this.removeLoader();
                        $('#conferma').prop("disabled", false);
                    })
                }else {
                    this.doPlayCodeCall(codice);
                }
            }else{
                $('#conferma').prop("disabled", false);
            }

        }else{
            $('#conferma').prop("disabled", false);
        }

    }

    doPlayCodeCall(codice){
        RestManager.playCode(codice).then((resp)=>{
            console.log(resp);
            if(resp.response.data.play_status == "WIN"){
                this.buildModal("https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-monopattino.png","Il Monopattino elettrico Razor con il kit di protezione è tuo!", "Hai guadagnato  <b>"+this.printPuntiOrPunto(resp.response.data.play_points)+"</b> per richiedere lo Zainetto che si illumina al buio.", "/promozioni/il-divertimento-e-fuori/richiedi-premio?pt="+resp.status.play_token.data, "Richiedi il premio")
            }else{
                if(resp.response.data.points_left >= 4){
                    this.buildModal("https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-zainetto.png","Purtroppo non hai vinto il Monopattino elettrico Razor con il kit di protezione!", "Hai comunque raccolto i punti necessari per richiedere lo <b>Zainetto</b> che si illumina al buio.", "/promozioni/il-divertimento-e-fuori/richiedi-premio", "Richiedi il premio")
                }else{
                    this.buildModal("https://static.mulinobianco.it/pew/KIDS_2019/assets/img/visual-top-monopattino.png","Purtroppo non hai vinto il Monopattino elettrico Razor con il kit di protezione!", "Hai guadagnato <b>"+this.printPuntiOrPunto(resp.response.data.play_points)+"</b> per richiedere lo <b>Zainetto</b> che si illumina al buio.", "/promozioni/il-divertimento-e-fuori/area-personale", "Torna al concorso")
                }
            }

            $('#conferma').prop("disabled", false);
            this.removeLoader();
        }, (err)=>{
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.status.errors.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
            $('#conferma').prop("disabled", false);
            this.removeLoader();
        });
    }

    printPuntiOrPunto(num){
        return num > 1 ? num + " punti" : num + " punto";
    }

    take_code(){
        if( $('#codice').length ){
            var codice = $('#codice').val();
            if (codice.length < 2 & codice !== undefined) {
                $('#codice').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else if((codice.length > 1 && codice.length < 8) || codice.length > 8) {
                $('#codice').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il codice deve essere di 8 caratteri </span>');
            }else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_acceptance(){
        if( $('#acceptance').length ){
            if($('#acceptance').prop("checked") == false){
                $('#acceptance').addClass('error');
                $('.custom-row--acceptance').append('<span class="error-feedback"><span class="icon-error">!</span> Attenzione! Devi aver letto e accettato il regolamento.</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }



    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
    }

    startLoader(){
        $('.mb-promo-kids-2019').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
    }


    buildModal(img, title, text, link, linkCta){
        let modalTmpl = `
            <div class="feedback__modal" component="FeedbackModalComponent">
                <div class="feedback__modal__wrap">
                    <div class="feedback__modal__close" component-click="close()">
                        <svg>
                        <use xlink:href="#svg_circle_close"></use>
                        </svg>
                    </div>
                    <div class="feedback__modal__content">
                        <img src="${img}">
                        <h2>${title}</h2>
                        <p>${text}</p>
                        <a class="button more-padding" href="${link}">${linkCta}</a>
                    </div>
                 </div>
            </div>`
        $('.mb-promo-kids-2019').append(modalTmpl);
        this.loadChildComponents(this);

    }

}

export default GiocaCodiceCtrl;
